import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Typography } from '@material-ui/core';
import { ArrowForwardIos, Error as ErrorIcon } from '@material-ui/icons';

import { useFormatMessage } from '../../intl/intl';
import dialogsManagerActions from '../../redux/actions/dialogsManager.actions';

import useStyles from './RTReportButton.styles';

export function RTReportButton(props: Props) {
  const {
    orderId = NaN,
    storeId = NaN,
    classes = {},
    setBG = false,
    showCaption = false,
  } = props;

  const dispatch = useDispatch();
  const styles = useStyles({ setBG });

  const ctText = useFormatMessage({ id: 'rtReportButton.smallText' });
  const captionText = useFormatMessage({ id: 'rtReportButton.captionText' });

  const handleClick = () => {
    dispatch(
      dialogsManagerActions.openRTReportReasonsDialog({ orderId, storeId }),
    );
  };

  return (
    <Button
      classes={classes}
      onClick={handleClick}
      className={styles.ctBtn}
      endIcon={<ArrowForwardIos />}
    >
      <Box className={styles.btnContent}>
        <ErrorIcon />
        <Typography className={styles.ctText}>{ctText}</Typography>
        {showCaption && (
          <Typography className={styles.captionText}>{captionText}</Typography>
        )}
      </Box>
    </Button>
  );
}

interface Props {
  orderId: number;
  storeId: number;
  classes?: any;
  setBG?: boolean;
  showCaption?: boolean;
}
